export const environment = {
  production: true,
  envName: 'prod',
  apiUrl: 'https://api-dcssportal.ga.gov',
  sitUrl: 'https://api-testdcssportal.ga.gov',
  devUrl: 'https://api-devdcssportal.ga.gov ',
  uatUrl: 'https://api-uatdcssportal.ga.gov',
  prodUrl: 'https://api-dcssportal.ga.gov',
  developmentUrl: 'http://localhost:9001',
  paymentUrl: 'https://ga.smartchildsupport.com/Mobile',
  dcssPublicApiToken: 'dcssIHJxC?hlHlBY0X0qBnmPigJQ0dQoPWXDuwTC',
  mobParams: {}
};
